import { useMemo as l } from "react";
import { S as c } from "../../index-LgiXwH_r.js";
const s = [c.createFont], r = (t, o) => {
  const n = l(
    () => Object.keys(t.stepName).filter((e) => !s.includes(e)).map((e) => ({
      value: e,
      label: t.stepName[e]
    })).sort((e, a) => e.label.localeCompare(a.label)),
    [t]
  ), p = l(
    () => o.actionType ? {
      value: o.actionType,
      label: t.stepName[o.actionType]
    } : null,
    [o.actionType, t.stepName]
  );
  return {
    actionTypeOptions: n,
    selectedActionTypeOption: p
  };
};
export {
  r as useActionTypeOptions
};
